<template>
  <div class="checkout-terms">
    <validation-provider tag="div" class="terms-checkbox" :rules="{required: { allowFalse: false }}"
                         v-slot="{ errors }">
      <base-checkbox variant="green"
                     v-model="currentValue">
        <span
            v-html="termsAndPolicyText">
        </span>
      </base-checkbox>
      <p class="error-msg" v-if="errors.length">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import BaseCheckbox from '../../base/base-checkbox'
import { englishLanguage, termsLinks, termsLinksEn } from '@/config/constants'

export default {
  name: 'checkout-payment-terms',
  components: { BaseCheckbox },
  props: {
    value: {
      required: true,
      default: false
    },
    isTouristFlow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.$props.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    },
    pageLanguage () {
      return this.$i18n.locale || ''
    },
    termsAndPolicyText () {
      return this.isTouristFlow
        ? this.$t('checkout.infoAndPayment.termsOfUseTextESIM', {
          terms: this.termsAndPolicyLinks.termsLink
        })
        : this.$t('checkout.infoAndPayment.termsOfUseText', {
          terms: this.termsAndPolicyLinks.termsLink,
          policy: this.termsAndPolicyLinks.policyLink
        })
    },
    termsAndPolicyLinks () {
      return this.pageLanguage === englishLanguage ? termsLinksEn : termsLinks
    }
  }
}
</script>

<style scoped lang="scss">
.checkout-terms {
  padding: 3rem 0 1rem;

  .terms-checkbox {
    position: relative;
    padding-bottom: 2rem;
  }
}

.error-msg {
  display: block;
  position: absolute;
  bottom: 3px;
  left: 34px;
  text-align: left;
  font-size: 1.2rem;
  line-height: 1;
  color: $error;
  margin-bottom: 0;
}
</style>
